import Modal from 'react-modal'
import Keypad from '../organisms/Keypad'
import css from './PinModal.module.scss'

export default function PinModal({ closeFunction }) {
	return (
		<Modal
			isOpen={true}
			shouldCloseOnOverlayClick={true}
			onRequestClose={closeFunction}
			className={css['modal']}
			overlayClassName={css['overlay']}>
			<Keypad
				mode='edit'
				closeFunction={closeFunction}
			/>
		</Modal>
	)
}
